import { Stack, Typography, Chip } from "@mui/material";
import { FC } from "react";
import { MetaBlock as MetaBlockType } from "../types";

interface MetaBlockProps {
  meta: MetaBlockType;
  theme: string;
}

const MetaBlock: FC<MetaBlockProps> = ({ meta, theme }) => {
  const getThemeStyles = () => {
    switch (theme) {
      case "haianh":
        return {
          color: "#666",
          fontSize: 12,
          chip: {
            backgroundColor: "#FFF3D4",
            color: "#CC9A05",
            fontSize: 10,
          },
        };
      case "nova-press":
        return {
          color: "#666",
          fontSize: 12,
          chip: {
            backgroundColor: "#E8F5E8",
            color: "#01A750",
            fontSize: 10,
          },
        };
      default:
        return {
          color: "#666",
          fontSize: 12,
          chip: {
            backgroundColor: "#f5f5f5",
            color: "#666",
            fontSize: 10,
          },
        };
    }
  };

  const themeStyles = getThemeStyles();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ flexWrap: "wrap", gap: 1 }}
      {...meta.stackProps}
    >
      {meta.date && (
        <Typography
          variant="caption"
          sx={{
            color: themeStyles.color,
            fontSize: themeStyles.fontSize,
          }}
        >
          {meta.date}
        </Typography>
      )}

      {meta.author && (
        <Typography
          variant="caption"
          sx={{
            color: themeStyles.color,
            fontSize: themeStyles.fontSize,
          }}
        >
          Tác giả: {meta.author}
        </Typography>
      )}

      {meta.category && (
        <Chip
          label={meta.category}
          size="small"
          sx={{
            height: 20,
            fontSize: themeStyles.chip.fontSize,
            backgroundColor: themeStyles.chip.backgroundColor,
            color: themeStyles.chip.color,
            fontWeight: 500,
          }}
        />
      )}

      {meta.readTime && (
        <Typography
          variant="caption"
          sx={{
            color: themeStyles.color,
            fontSize: themeStyles.fontSize,
          }}
        >
          {meta.readTime} phút đọc
        </Typography>
      )}
    </Stack>
  );
};

export default MetaBlock;
